"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultProps = {
  componentName: "card",
  elementType: "",
  position: [],
  props: {
    //editable part
    style: {
      background: "",
      border: "",
      color: "",
      hoverColor: "",
      fontSize: "",
      textTransform: ""
    },
    text: {
      title: "TOP CARACO CARO",
      productURL: "",
      price: "76.50",
      srcURL: "https://ik.imagekit.io/marketcube/platform/no-image.png",
      alt: "alt text"
    }
  }
};

exports.default = defaultProps;